import React, { useState, useContext } from 'react'
import { withRouter } from 'react-router-dom'
import AuthenticatedPage from 'containers/AuthenticatedPage'
import ModuleForm from 'components/AppHome/AppLayout/ModuleForm'
import Layout from 'components/AppHome/AppLayout/Layout'
import { SplitContext } from 'containers/SplitContext'
import SPLIT_FEATURES from 'containers/SplitContext/features'
import { APP_PAGES } from 'components/Engage/utils'
import ModulesProvider, {
  ModulesContext,
} from 'components/AppHome/AppLayout/ModulesProvider'

export const LayoutContext = React.createContext()

const ENABLE_SEGMENT_CONFIG = (splits) => {
  return (
    splits?.[SPLIT_FEATURES.COMPASS_DYNAMIC_LAYOUT_SEGMENT_CONFIG]
      ?.treatment === 'on'
  )
}

const LayoutProvider = ({ children, router }) => {
  const [layout, setLayout] = useState({
    name: router.match.params.id?.split('_')[0] || 'Default',
  })
  const [isDraft, setIsDraft] = useState(false)
  const [segment, setSegment] = useState(() => {
    const segmentName = new URLSearchParams(router.location.search).get(
      'segment'
    )
    return segmentName ? { name: segmentName } : null
  })

  const { splits } = React.useContext(SplitContext)
  const enableSegmentConfig = ENABLE_SEGMENT_CONFIG(splits)
  const hasFilter = Boolean(segment)

  return (
    <LayoutContext.Provider
      value={{
        layout,
        setLayout,
        segment,
        setSegment,
        enableSegmentConfig,
        hasFilter,
        router,
        isDraft,
        setIsDraft,
      }}
    >
      {children}
    </LayoutContext.Provider>
  )
}

const DynamicLayoutContent = () => {
  const { enableSegmentConfig, hasFilter, segment, setLayout, router } =
    useContext(LayoutContext)
  const { moduleValues } = React.useContext(ModulesContext)
  const { action, id } = router.match.params

  const onCancel = () => {
    if (hasFilter) {
      router.history.push(`/app-home/dynamic-layout?segment=${segment.name}`)
    } else {
      router.history.push('/app-home/dynamic-layout')
    }
  }

  return (
    <div className="applayout-container">
      {!action && <Layout />}
      {action && Object.keys(moduleValues).length > 0 && (
        <ModuleForm
          router={router}
          segment={segment}
          page={APP_PAGES[0]}
          setLayout={setLayout}
          hasFilter={hasFilter}
          layout={id.split('_')[0]}
          moduleType={id.split('_')[1]}
          moduleValues={moduleValues[id.split('_')[2]]}
          enableSegmentConfig={enableSegmentConfig}
          onCancel={onCancel}
        />
      )}
    </div>
  )
}

const ManageLayout = ({ menu, router }) => {
  return (
    <AuthenticatedPage menu={menu}>
      <LayoutProvider router={router}>
        <ModulesProvider>
          <DynamicLayoutContent />
        </ModulesProvider>
      </LayoutProvider>
    </AuthenticatedPage>
  )
}

export default withRouter(({ location, history, match, ...props }) => (
  <ManageLayout router={{ location, history, match }} {...props} />
))
